module.exports = __webpack_public_path__ + "static/TQ_pyramid-9548bdf4617c49db5b4ca1ca0b7c3e7c.png";